module.exports = __webpack_public_path__ + "img/ilong-profile-photo.d33c6116.png";